// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","256":"component---src-templates-blog-tsx","317":"a9729dbb8077d9037af2b38a918523c804fb2cd6","453":"component---src-pages-404-tsx"}[chunkId] + "-" + {"245":"82dabef0d84d283b1b1f","256":"4ca1b6ee468725af9cf4","317":"e3d9d7951eef7092bc91","453":"b1582c2fa2dc73d9a611"}[chunkId] + ".js";
};